<template>
  <div class="centerBox">
    <!-- 头部 -->
    <div class="BoxHead">
      <div class="headLeft">
        <div class="leftJt" @click="toBack">
          <svg-btn class="leftIcon" icon-class="icon-left"></svg-btn>
        </div>
        <div class="headright">{{ tag_name }}</div>
      </div>
    </div>

    <!-- 主体内容 -->
    <div class="BoxContent">
      <!-- 排序方式 -->
      <div class="head">
        <div class="font1">排序方式</div>
        <ClickPop @close="closeSelet" class="ClickPop">
          <div class="font2Box" @click="toggleRotation">
            <div class="font2">{{ typeName }}</div>
            <svg-btn
              :class="{ select: true, rotated: isOpen }"
              icon-class="icon-gfans-select"
            ></svg-btn>
          </div>
          <div slot="content" class="arrCheck">
            <div
              class="check"
              @click="checkType(item)"
              v-for="(item, index) in checkList"
              :key="index"
            >
              <div class="bor">
                <span class="fontyes font3">{{ item.name }}</span>
              </div>
              <svg-btn
                v-if="typeName == item.name"
                class="yesIcon"
                icon-class="icon-yes"
              ></svg-btn>
            </div>
          </div>
        </ClickPop>
        <div class="inputBox">
          <el-input
            class="commitInput"
            resize="none"
            autosize
            @keydown.enter.native="search"
            placeholder="请输入内容"
            v-model="keyword"
          >
          </el-input>
          <svg-btn
            @click="search"
            class="inputIcon"
            icon-class="icon-search"
          ></svg-btn>
        </div>
      </div>
      <!-- 骨架屏 -->
      <div v-if="loading" class="skeleton-wrapper">
        <div class="skeleton-columns">
          <!-- 左侧列骨架屏 -->
          <div class="skeleton-column">
            <div v-for="i in skeletonCount" :key="i" class="skeleton-item">
              <div class="skeleton-content">
                <div
                  class="skeleton-img"
                  :style="{ height: getSkeletonImageHeight(i, 'left') }"
                ></div>
                <div class="skeleton-title"></div>
                <div class="skeleton-author">
                  <div class="skeleton-avatar"></div>
                  <div class="skeleton-name"></div>
                </div>
              </div>
            </div>
          </div>

          <!-- 右侧列骨架屏 -->
          <div class="skeleton-column">
            <div
              v-for="i in skeletonCount"
              :key="i + skeletonCount"
              class="skeleton-item"
            >
              <div class="skeleton-content">
                <div
                  class="skeleton-img"
                  :style="{ height: getSkeletonImageHeight(i, 'right') }"
                ></div>
                <div class="skeleton-title"></div>
                <div class="skeleton-author">
                  <div class="skeleton-avatar"></div>
                  <div class="skeleton-name"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 列表主体内容 -->
      <Waterfall
        v-if="!loading && total > 0"
        :arrList="arrList"
        :isLoading="isLoading"
        :isFind="true"
        :noMoreData="noMoreData"
        @load-more="handleLoadMore"
        @image-loaded="handleImageLoad"
        @image-error="handleImageError"
        @remove-item="handleRemoveItem"
      />
      <!-- 暂无标签内容 数据缺省 -->
      <div class="noneData" v-show="!loading && isInitialEmpty">
        <img
          class="noneIcon"
          :src="
            $utils.getPng(
              $store.state.theme == 'light'
                ? 'icon-gfans-none'
                : 'icon-gfans-none-dark'
            )
          "
        />
        <div class="font2">暂无标签内容</div>
      </div>

      <!-- 未找到该关键词内容 搜索缺省 -->
      <div class="noneData" v-show="!loading && isSearchEmpty">
        <img
          class="noneIcon"
          :src="
            $utils.getPng(
              $store.state.theme == 'light'
                ? 'icon-gfans-noSearch'
                : 'icon-gfans-noSearch-dark'
            )
          "
        />
        <div class="font2">未找到该关键词内容</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTab } from '@/axios/tab'
import ClickPop from '@/components/ClickPop/index'
import Waterfall from '@/components/waterFall/vue-waterfall.vue'
export default {
  components: {
    ClickPop,
    Waterfall,
  },
  data() {
    return {
      checkList: [
        { id: 4, name: '最热推荐' },
        { id: 5, name: '最多收藏' },
        { id: 6, name: '最多点赞' },
        { id: 1, name: '最新发布' },
      ],
      keyword: '',
      defaultActive: 0,
      arrList: [],
      loading: true,
      isLoading: false,
      noMoreData: false,
      page: 1,
      limit: 30,
      total: null,
      sort_type: 4,
      typeName: '最热推荐',
      tag_name: '', //标签名称
      isOpen: false,
      firstScreenCount: 6, // 首屏显示数量
      persistedStates: new Map(), // 持久化存储图片状态
      is_keyword: 0, // 是否已执行搜索
      skeletonCount: 5, // 每列显示的骨架屏数量
    }
  },
  // watch: {
  //   '$route.params.id'() {
  //     this.scrollToTop()
  //     this.loading = true
  //     this.isLoading = false
  //     this.noMoreData = false
  //     this.total = null
  //     this.arrList = []
  //     this.page = 1
  //     this.limit = 30
  //     // 重置持久化状态
  //     this.persistedStates = new Map()
  //     this.fetchData()
  //   },
  // },
  created() {
    this.fetchData()
  },
  computed: {
    // 计算属性：判断是否为初始无数据状态
    isInitialEmpty() {
      return !this.loading && this.total == 0 && this.is_keyword == 0
    },

    // 计算属性：判断是否为搜索无结果状态
    isSearchEmpty() {
      return !this.loading && this.total == 0 && this.is_keyword == 1
    },
  },
  methods: {
    //变更子组件收藏状态
    handleRemoveItem(itemInfo) {
      const { file_id, stype } = itemInfo
      const itemIndex = this.arrList.findIndex(
        item => item.file_id == file_id && item.stype == stype
      )
      if (itemIndex !== -1) {
        // 使用Vue.set确保响应式更新
        this.$set(
          this.arrList[itemIndex],
          'is_collect',
          this.$utils.checkNum(this.arrList[itemIndex].is_collect)
        )
      }
    },
    toBack() {
      if (this.$store.state.isLogin == 0) {
        this.$router.push({ path: '/discover' })
      } else {
        this.$router.push({ path: '/subscribe' })
      }
    },
    //关闭下拉框
    closeSelet() {
      this.isOpen = false
    },
    //点击切换排序方式
    toggleRotation() {
      // 切换旋转状态
      this.isOpen = !this.isOpen
    },
    // 生成阶梯式高度
    getSkeletonImageHeight(index, column) {
      const heights = [180, 240, 200, 260, 220] // 阶梯高度集合
      const offset = column === 'left' ? 0 : 2 // 左右列错开两个高度值
      return `${heights[(index + offset) % heights.length]}px`
    },
    //初始化数据
    async fetchData() {
      if (this.isLoading || this.noMoreData) return
      this.isLoading = true
      try {
        let data = {
          tag: this.$route.params.id,
          sort_type: this.sort_type, //	 4-最热推荐 5-最多收藏 6-最多点赞 7-置顶-最新发布
          keyword: this.keyword.trim(),
          page: this.page,
          limit: this.limit,
        }
        let res = await getTab(data)
        if (res.status == 1) {
          document.title = res.data.tag_name + ' - Gfans'
          const globalIndexBase = (this.page - 1) * this.limit
          // 处理数据时添加状态属性
          const processedList = res.data.list.map((item, index) => {
            const globalIndex = globalIndexBase + index
            const persistedState = this.persistedStates.get(globalIndex) || {}
            return {
              ...item,
              visible: this.page === 1 && index < this.firstScreenCount,
              isLoaded: persistedState.isLoaded || false,
              imageError: persistedState.imageError || false,
              blurStyle: persistedState.isLoaded ? '' : 'blur(15px)',
              originalIndex: globalIndex, // 存储全局唯一索引
              _uid: `${item.file_id || globalIndex}_${Date.now()}`, // 添加唯一标识
            }
          })
          this.arrList =
            this.page == 1
              ? processedList // 首页直接赋值
              : [...this.arrList, ...processedList] // 后续页追加数据
          this.total = Number(res.data.total)
          this.is_keyword = res.data.is_keyword
          this.tag_name = res.data.tag_name
          this.noMoreData = this.arrList.length >= this.total
          this.page++
          this.loading = false
          this.isLoading = false
        }
      } catch (e) {
        this.loading = false
        this.isLoading = false
        this.noMoreData = true
      }
    },

    handleLoadMore() {
      this.fetchData()
    },

    // 处理图片加载成功事件
    handleImageLoad(payload) {
      const { originalIndex, isLoaded } = payload
      // 更新持久化状态
      this.persistedStates.set(originalIndex, {
        isLoaded: true,
        imageError: false,
      })

      // 更新当前列表中对应项的状态
      const item = this.arrList.find(
        item => item.originalIndex === originalIndex
      )
      if (item) {
        this.$set(item, 'isLoaded', true)
        this.$set(item, 'blurStyle', '')
      }
    },

    // 处理图片加载失败事件
    handleImageError(payload) {
      const { originalIndex, imageError } = payload
      // 更新持久化状态
      this.persistedStates.set(originalIndex, {
        isLoaded: false,
        imageError: true,
      })

      // 更新当前列表中对应项的状态
      const item = this.arrList.find(
        item => item.originalIndex === originalIndex
      )
      if (item) {
        this.$set(item, 'imageError', true)
        this.$set(item, 'isLoaded', false)
      }
    },
    //切换排序方式
    checkType(item) {
      this.sort_type = item.id
      this.typeName = item.name
      this.search()
    },
    //搜索
    search: _.debounce(
      function () {
        this.scrollToTop()
        this.loading = true
        this.isLoading = false
        this.noMoreData = false
        this.arrList = []
        this.page = 1
        this.limit = 30
        this.persistedStates = new Map()
        this.fetchData()
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //切换tab
    handleTabChange(row) {
      this.defaultActive = row
      this.search()
    },
    // 回到顶部
    scrollToTop() {
      window.scrollTo(0, 0)
    },
  },
}
</script>

<style lang="scss" scoped>
.centerBox {
  margin-top: -72px;
  .BoxHead {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: sticky;
    top: 0;
    z-index: 400;
    height: 72px;
    min-height: 72px;
    max-width: 600px;
    width: 100%;
    padding-left: 2px;
    .headLeft {
      display: flex;
      align-items: center;
      .avatar-container {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        overflow: hidden;
      }

      .headImg {
        width: 40px;
        height: 40px;
        object-fit: cover;
        border-radius: 50%;
        flex-shrink: 0;
      }

      .info {
        display: flex;
        flex-direction: column;
        margin-left: 12px;
        max-width: 367px;

        .font1 {
          font-weight: 500;
          font-size: 14px;
          line-height: 22px;
          max-width: 367px;
          min-width: 75px;
          @include multiline(1);
          @include useTheme {
            color: getVar('text-color1-2c2c2c');
          }
        }

        .font2 {
          font-weight: 400;
          font-size: 12px;
          line-height: 18px;
          @include multiline(1);
          @include useTheme {
            color: getVar('text-color3-90969c');
          }
        }
      }
      .leftJt {
        width: 36px;
        height: 36px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        margin-right: 12px;
        @include useTheme {
          color: getVar('text-color1-2c2c2c');
        }
        .leftIcon {
          width: 18px;
          height: 18px;
        }
        &:hover {
          @include useTheme {
            background: getVar('bg-color1-f4f6f8');
          }
        }
      }
    }
    .headright {
      max-width: 536px;
      font-weight: 600;
      font-size: 18px;
      line-height: 26px;
      @include useTheme {
        color: getVar('text-color1-2c2c2c');
      }
    }
  }

  @media (max-width: 1100px) {
    .BoxHead {
      width: calc(100% - 600px);
      min-width: 500px;
      max-width: 100%;
    }
  }
  /* 当屏幕宽度小于等于700px时 */
  @media (max-width: 700px) {
    .BoxHead {
      width: calc(100% - 600px);
      min-width: 420px;
      max-width: 100%;
    }
  }
  /* 当屏幕宽度小于等于600px时 */
  @media (max-width: 600px) {
    .BoxHead {
      width: calc(100% - 600px);
      min-width: 350px;
      max-width: 100%;
    }
  }
  /* 当屏幕宽度小于等于550px时 */
  @media (max-width: 550px) {
    .BoxHead {
      width: calc(100% - 600px);
      min-width: 250px;
      max-width: 100%;
    }
  }
  .BoxContent {
    // padding: 0 16px 16px 16px;
    width: 100%;
    height: 100%;
    border-radius: 16px 16px 0px 0px;
    @include useTheme {
      background: getVar('bg-color-content');
    }
    .head {
      display: flex;
      align-items: center;
      position: sticky;
      top: 72px;
      z-index: 200;
      padding: 16px;
      width: 100%;
      border-radius: 16px 16px 0px 0px;
      // width: calc(100% + 1px);
      @include useTheme {
        background: getVar('bg-color-content');
      }
      .font1 {
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        flex-shrink: 0;
        margin-right: 12px;
        @include useTheme {
          color: getVar('text-color3-90969c');
        }
      }
      .font2Box {
        width: 144px;
        height: 32px;
        padding: 5px 16px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        margin-right: 20px;
        @include useTheme {
          border: 1px solid getVar('border-color1');
        }
        .font2 {
          max-width: 96px;
          font-weight: 400;
          font-size: 14px;
          line-height: 22px;
          margin-right: 8px;
          @include useTheme {
            color: getVar('text-color1-2c2c2c');
          }
        }
        .select {
          width: 16px;
          height: 16px;
          transition: transform 0.5s ease;
        }
        .rotated {
          transform: rotate(180deg);
        }
      }
      .inputBox {
        position: relative;
        flex: 1;
        ::v-deep .commitInput {
          .el-input__inner {
            height: 40px !important;
            border-radius: 20px;
            padding: 9px 40px 9px 16px !important;
            font-weight: 400;
            font-size: 14px;
            line-height: 22px;
            border: 1px solid transparent;
            white-space: pre-wrap;
            word-break: break-all;
            overflow-y: auto !important;
            // transition: padding-left 0.2s;
            @include useTheme {
              color: getVar('text-color1-2c2c2c');
              caret-color: getVar('primary-color');
              background: getVar('bg-color14-f4f6f8');
            }
            &::placeholder {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              line-height: 22px;
              @include useTheme {
                color: getVar('text-color6-b8bec4');
              }
            }
            &:hover {
              @include useTheme {
                border: 1px solid getVar('primary-color');
              }
            }
            &:focus {
              transition: padding-left 0.2s;
              padding-left: 16px;
              @include useTheme {
                outline: 2px solid getVar('primary-color4');
                border: 1px solid getVar('primary-color');
                background: getVar('bg-color-content');
              }
            }
          }
        }
        .inputIcon {
          position: absolute;
          right: 12px;
          top: 50%;
          transform: translateY(-50%);
          cursor: pointer;
          @include useTheme {
            color: getVar('text-color6-b8bec4');
          }
        }
      }
      .arrCheck {
        .fontyes {
          margin-left: 0 !important;
          margin-right: 25px !important;
          width: 70px !important;
        }
      }
      ::v-deep .click-pop {
        .click-pop-box {
          right: 20px !important;
        }
      }
    }
  }
  .noneData {
    position: fixed;
    border-radius: 0;
    padding-top: 172px;
    height: calc(100% - 72px);
  }
  .skeleton-wrapper {
    padding: 0 16px;
    .skeleton-columns {
      display: flex;
      gap: 16px;
    }

    .skeleton-column {
      flex: 1;
    }

    .skeleton-item {
      margin-bottom: 16px;
      border-radius: 16px;
      overflow: hidden;
      animation: skeleton-pulse 1.5s infinite;
      @include useTheme {
        background: getVar('bg-color-content');
      }
    }

    .skeleton-content {
      border-radius: 16px;
      overflow: hidden;
    }

    .skeleton-img {
      width: 100%;
      border-radius: 16px 16px 0 0;
      height: 200px; /* 默认高度，由JS动态覆盖 */
      @include useTheme {
        background: getVar('bg-color1-f4f6f8');
      }
    }

    .skeleton-title {
      height: 20px;
      width: 80%;
      margin: 12px 0;
      border-radius: 4px;
      @include useTheme {
        background: getVar('bg-color1-f4f6f8');
      }
    }

    .skeleton-author {
      display: flex;
      align-items: center;
      padding: 0 0 12px 0;
    }

    .skeleton-avatar {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      @include useTheme {
        background: getVar('bg-color1-f4f6f8');
      }
    }

    .skeleton-name {
      height: 16px;
      width: 100px;
      margin-left: 8px;
      border-radius: 4px;
      @include useTheme {
        background: getVar('bg-color1-f4f6f8');
      }
    }

    @keyframes skeleton-pulse {
      0%,
      100% {
        opacity: 0.6;
      }
      50% {
        opacity: 0.4;
      }
    }
  }
}
</style>
